
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor/news/[slug]",
      function () {
        return require("private-next-pages/investor/news/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor/news/[slug]"])
      });
    }
  